/** Strings owned by the share area — the guest page at `/s/<token>`. */
export const SHARE_STRINGS = {
    // ── Page chrome ─────────────────────────────────────────────────────────────
    'share.page_title': { en: '{device} — shared device', ru: '{device} — общий доступ к устройству' },
    'share.link_unavailable': { en: 'Link unavailable', ru: 'Ссылка недоступна' },
    'share.link_invalid': { en: 'This link is invalid or has expired.', ru: 'Ссылка недействительна или истекла.' },
    'share.server_unreachable': {
        en: 'Could not reach the server. Check your connection and try again.',
        ru: 'Не удалось связаться с сервером. Проверьте соединение и попробуйте снова.',
    },
    // ── Time left ───────────────────────────────────────────────────────────────
    'share.expired': { en: 'expired', ru: 'истекла' },
    'share.min_left': { en: '{min} min left', ru: 'осталось {min} мин' },
    'share.h_left': { en: '{h} h left', ru: 'осталось {h} ч' },
    'share.h_min_left': { en: '{h} h {m} min left', ru: 'осталось {h} ч {m} мин' },
    // ── Stream status ───────────────────────────────────────────────────────────
    'share.connecting': { en: 'Connecting…', ru: 'Подключение…' },
    'share.reconnecting': { en: 'Reconnecting…', ru: 'Переподключение…' },
    'share.in_use_by': {
        en: 'This device is currently in use by {by}.',
        ru: 'Устройство сейчас занято: {by}.',
    },
    // ── Navigation buttons ──────────────────────────────────────────────────────
    'share.nav_home': { en: 'Home', ru: 'Домой' },
    'share.nav_recent': { en: 'Recent apps', ru: 'Недавние приложения' },
    // ── Camera passthrough ──────────────────────────────────────────────────────
    'share.share_camera': { en: 'Share my camera', ru: 'Транслировать мою камеру' },
    'share.camera': { en: 'Camera', ru: 'Камера' },
    'share.camera_facing_rear': { en: 'Rear camera — tap to switch', ru: 'Основная камера — нажмите, чтобы переключить' },
    'share.camera_facing_front': { en: 'Front camera — tap to switch', ru: 'Фронтальная камера — нажмите, чтобы переключить' },
    'share.camera_starting': { en: 'Starting…', ru: 'Запуск…' },
    'share.camera_streaming': { en: 'Streaming', ru: 'Трансляция' },
    'share.camera_needs_https': {
        en: 'This browser cannot share a camera (an HTTPS connection is required).',
        ru: 'Этот браузер не может транслировать камеру (нужно соединение по HTTPS).',
    },
    'share.camera_denied': { en: 'Camera access was denied.', ru: 'Доступ к камере отклонён.' },
    'share.camera_not_found': { en: 'No camera was found on this device.', ru: 'На этом устройстве камера не найдена.' },
    'share.camera_start_failed': { en: 'Could not start the camera.', ru: 'Не удалось запустить камеру.' },
    'share.camera_preview_failed': {
        en: 'Could not start the camera preview.',
        ru: 'Не удалось запустить предпросмотр камеры.',
    },
    'share.camera_not_accepted': {
        en: 'The device did not accept the camera stream.',
        ru: 'Устройство не приняло трансляцию камеры.',
    },
    'share.camera_rejected': {
        en: 'The device rejected the camera stream.',
        ru: 'Устройство отклонило трансляцию камеры.',
    },
};
